module.exports = __webpack_public_path__ + "img/booking_Edit.2a810d32.svg";